import { styled } from '@mui/material/styles';
import { Box, buttonBaseClasses, formControlLabelClasses } from '@mui/material';
import { Checkbox } from 'app/components';

export const SelectAllCheckboxStyled = styled(Checkbox, {
  name: 'SelectAllCheckboxStyled',
})(({ theme }) => ({
  [`& .${formControlLabelClasses.label}`]: {
    color: theme.palette.primary.dark,
    marginLeft: 1,
  },
  [`& .${formControlLabelClasses.root}`]: {
    marginLeft: 0,
  },
  [`& .${buttonBaseClasses.root}`]: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export const ListHeaderRowStyled = styled(Box, {
  name: 'ListHeaderRowStyled',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[100],
  borderBottom: `1px solid ${theme.palette.divider}`,
  minHeight: '2.7em',
  paddingRight: theme.spacing(2),
}));
